import { CITY_PHOTOS } from '../lib/city-photos';
import { useSeo } from '../lib/seo';
import { t } from '../lib/i18n';

/**
 * Who took the city photos, and under what terms.
 *
 * Not a formality: CC BY and CC BY-SA require naming the author, linking the
 * licence and saying what was changed, and a photo shown without that is being
 * used outside its licence. Everything here is rendered from the same table the
 * tiles read, so the two cannot drift apart.
 */
export default function PhotoCredits() {
  useSeo({ title: t("Crédits photos"), description: t("Auteurs et licences des photos des villes sur Bedly.") });

  return (
    <div className="page page--mid stack stack--loose">
      <div className="stack stack--tight">
        <h1 style={{ fontSize: 26 }}>{t("Crédits photos")}</h1>
        <p className="muted small" style={{ margin: 0 }}>
          {t("Les photos des villes proviennent de Wikimedia Commons, sous licences libres. Elles ont été recadrées et redimensionnées pour l’affichage. Merci à leurs auteurs.")}
        </p>
      </div>

      <div className="grid" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))' }}>
        {Object.entries(CITY_PHOTOS).map(([slug, photo]) => (
          <figure key={slug} className="card" style={{ margin: 0 }}>
            <img
              src={photo.src}
              alt={t('Photo de {city}', { city: photo.city })}
              loading="lazy"
              width={640}
              height={480}
              style={{ width: '100%', height: 'auto', display: 'block', aspectRatio: '4 / 3', objectFit: 'cover' }}
            />
            <figcaption className="card__body stack stack--tight small">
              <strong>{photo.city}</strong>
              <span>
                {t("Photo :")} {photo.author}
              </span>
              <span>
                {t("Licence :")}{' '}
                {photo.licenceUrl ? (
                  <a href={photo.licenceUrl} target="_blank" rel="noopener noreferrer license">
                    {photo.licence}
                  </a>
                ) : (
                  photo.licence
                )}{' '}
                {t("· recadrée")}
              </span>
              <a href={photo.source} target="_blank" rel="noopener noreferrer">
                {t("Voir l’original sur Wikimedia Commons")}
              </a>
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  );
}
